import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore"; // Dodajemy obsługę bazy danych
import { getStorage } from "firebase/storage"; // 1. DODAJ TEN IMPORT
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyARpM2z9PuSUhLlIiLa9goPNBhbwgY3ORk",
  authDomain: "kapliczka-net-bda86.firebaseapp.com",
  projectId: "kapliczka-net-bda86",
  storageBucket: "kapliczka-net-bda86.firebasestorage.app",
  messagingSenderId: "1063220871458",
  appId: "1:1063220871458:web:d794851760b3b1a375a57b"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app); // Eksportujemy bazę, by użyć jej w App.js
export const storage = getStorage(app);
export const auth = getAuth(app);

